module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/arrow-caret-24d4cfa1b47b8585e56d4fcf1b38892f.svg";